<template>
    <div>
      <footer class="footer bg-slate-950 relative text-gray-200 dark:text-gray-200">
        <div class="container">
          <div class="grid grid-cols-12">
            <div class="col-span-12">
              <div class="py-[60px] px-0">
                <div class="grid grid-cols-1">
                  <div class="text-center">
                    <img src="../assets/images/logo-icon-64.png" class="block mx-auto" alt="RH Paie Plus">
                    <p class="max-w-xl mx-auto text-slate-400 mt-8">
                      RH Paie Plus accompagne les TPE et PME dans une gestion de paie fiable,
                      conforme et simplifiée. Votre partenaire de confiance pour sécuriser
                      toutes vos obligations sociales.
                    </p>
                  </div>

<!--
                  <ul class="list-none footer-list text-center mt-8">
                    <li class="inline px-2">
                      <router-link @click="scrollToTop" to="/services"
                                   class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out">
                        Services
                      </router-link>
                    </li>
                    <li class="inline px-2 mt-[10px]">
                      <router-link to="/aboutus"
                                   class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out ms-2">
                        À propos
                      </router-link>
                    </li>
                    <li class="inline px-2 mt-[10px]">
                      <router-link to="/blogs"
                                   class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out ms-2">
                        Blog
                      </router-link>
                    </li>
                    <li class="inline px-2 mt-[10px]">
                      <router-link to="/contact"
                                   class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out ms-2">
                        Contact
                      </router-link>
                    </li>
                  </ul>
-->
                  <!--end icon-->
                </div><!--end grid-->
              </div>
            </div>
          </div><!--end grid-->
        </div><!--end container-->

        <div class="py-[30px] px-0 border-t border-slate-800">
          <div class="container text-center">
            <div class="grid md:grid-cols-12 items-center">

              <!-- COPYRIGHT -->
              <div class="md:col-span-6">
                <div class="md:text-start text-center">
                  <p class="text-gray-400">
                    © {{ date }} RH Paie Plus. Tous droits réservés.
                  </p>
                </div>
              </div>

              <!-- SOCIALS -->
              <div class="md:col-span-6 md:mt-0 mt-8">
                <ul class="list-none md:text-end text-center">
                  <li class="inline">
                    <a href="#" target="_blank"
                       class="size-8 inline-flex items-center justify-center text-base border border-gray-800
                                rounded-md hover:border-violet-600 hover:bg-violet-600 transition duration-500 ease-in-out">
                      <i class="uil uil-linkedin" title="LinkedIn"></i>
                    </a>
                  </li>
                  <li class="inline">
                    <a href="#" target="_blank"
                       class="size-8 inline-flex items-center justify-center text-base border border-gray-800
                                rounded-md hover:border-violet-600 hover:bg-violet-600 transition duration-500 ease-in-out">
                      <i class="uil uil-facebook-f" title="Facebook"></i>
                    </a>
                  </li>
                  <li class="inline">
                    <a href="#" target="_blank"
                       class="size-8 inline-flex items-center justify-center text-base border border-gray-800
                                rounded-md hover:border-violet-600 hover:bg-violet-600 transition duration-500 ease-in-out">
                      <i class="uil uil-instagram" title="Instagram"></i>
                    </a>
                  </li>
                  <li class="inline">
                    <a href="#" target="_blank"
                       class="size-8 inline-flex items-center justify-center text-base border border-gray-800
                                rounded-md hover:border-violet-600 hover:bg-violet-600 transition duration-500 ease-in-out">
                      <i class="uil uil-envelope" title="Email"></i>
                    </a>
                  </li>
                </ul><!--end icon-->
              </div>

            </div>
          </div><!--end container-->
        </div>
      </footer>
      <!--end footer-->
        <!-- Footer End -->
    </div>
</template>

<script>
    export default {
        name: "footerVue",
        data(){
        return{
            date:new Date().getFullYear()
        }
    },
    mounted() {
        this.scrollToTop()
    },
    methods: {
        scrollToTop() {
    window.scrollTo(0,0);
  }
    },
    }
</script>

<style lang="scss" scoped>

</style>